import { CommonData } from "../../../datastructures/gamestate/gameData";
import { updateBalance } from "../../../functions/Functions_General";

//-place it where the game round ends and collect or autocollect
export function updateEmulationWinBalance(activeGameData:CommonData)
{   
  return //--do no update the  player win from the clinet
    //check if its emulation mode
    if(activeGameData.isEmulation)
    {   
    
        //check if its game's  round ended
        if(activeGameData.betResponse.gameContext.contextData.finished)
        { 
          //player winnings
          let gameContext= activeGameData.betResponse.gameContext.contextData;
          let playerWin= gameContext.gameRoundBalance.credits.amount;
        //   console.log(playerWin);
          activeGameData.betResponse.playerBalance.creditsBalance.amount+=playerWin;
          //-update the player balance
          updateBalance(activeGameData);
        }
    }
}


export function updateEmulationStakeUse(activeGameData:CommonData)
{   
  return //--do no update the  player win from the clinet
    //substract the stake amount
    if(activeGameData.isEmulation)
    {   

        // write the start balance at the begining
          activeGameData.betResponse.playerBalance.creditsBalance.amount
          updateBalance(activeGameData); 

        // get emulation index
        if(activeGameData.emulationMode.isStartOfRound())
        {   

            setTimeout(() => {
               //player stake
          let playerStake=activeGameData.betSelected.getServerVal()
        //   console.log(playerWin);
          activeGameData.betResponse.playerBalance.creditsBalance.amount-=playerStake;
          //-update the player balance
          updateBalance(activeGameData);  }, 150);

        }
    }
}

export function enableEmulationInterfaceOnFeatureSelect(activeGameData:CommonData,bool:boolean)
{
  if(activeGameData.isEmulation)
  {
    activeGameData.emulationMode.enableClickOnFeatureSelect(bool);
  }
  // console.log('here')
}

